import { createAction, props } from '@ngrx/store';
import { AddressBook } from '../../models/address-book';
import { AddressBooksQuery } from '../../models/address-books-query';

export const addressBooksTableRequest = createAction(
    '[Address Book Table] Load Request'
);

export const addressBooksTableSuccess = createAction(
    '[Address Book Table] Load Response',
    props<{ totalCount: number, page: AddressBook[] }>()
);

export const addressBooksTableFailure = createAction(
    '[Address Book Table] Load Failure'
);

export const addressBooksTableChangePage = createAction(
    '[Address Book Table] Change Page',
    props<{ pageNumber: number, itemsPerPage: number }>()
);

export const addressBooksTableChangeQuery = createAction(
    '[Address Book Table] Change Filter',
    props<{ query: AddressBooksQuery }>()
);

export const addressBooksTableSort = createAction(
    '[Address Book Table] Change Sort Column',
    props<{ id: string, descending: boolean }>()
);

export const addressBooksTableSetSelection = createAction(
    '[Address Book Table] Set Selection',
    props<{ selection: string[] }>()
);

export const addressBooksTableMasterToggle = createAction(
    '[Address Book Table] Master Selection Toggle'
);

export const addressBooksTableToggle = createAction(
    '[Address Book Table] Toggle Selection',
    props<{ id: string }>()
);

export const addressBooksTableAddAssist = createAction(
    '[Address Book Table] Add Filter Assist',
    props<{ id: string, parameter: any }>()
);

export const addressBooksTableRemoveAssist = createAction(
    '[Address Book Table] Remove Filter Assist',
    props<{ id: string }>()
);


